import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { useFormContext, Controller } from 'react-hook-form';
import { get } from 'lodash';
import { cn } from '@src/utils/ui';

export const TextInput = ({ name, ...rest }) => {
    const { control, formState } = useFormContext();
    const error = !!get(formState.errors, name);
    const helperText = get(formState.errors, `${name}.message`);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => <TextInputField {...field} {...rest} error={error} helperText={helperText} />}
        />
    );
};

export function TextInputField({ InputProps = {}, ...props }) {
    return (
        <TextField
            {...props}
            InputProps={{
                ...InputProps,
                className: cn('tw-text-[16px]', InputProps.className)
            }}
            SelectProps={{ className: 'tw-text-[16px]' }}
            InputLabelProps={{ className: 'tw-text-[16px]' }}
            FormHelperTextProps={{ className: 'tw-text-[12px]' }}
        />
    );
}

// -------- PropTypes -------- //

TextInput.propTypes = {
    name: PropTypes.string.isRequired,
    InputProps: PropTypes.object
};

TextInputField.prototype = TextInput.propTypes;
